import React from 'react';
import {
  Confetti1,
  Confetti2,
  Confetti3
} from './banner.about.confetti.styles';

const BannerAboutConfetti = ():JSX.Element => {
  return (
    <>
      <Confetti1 />
      <Confetti2 />
      <Confetti3 />
    </>
  );
};

export default BannerAboutConfetti;
